module.exports = __webpack_public_path__ + "static/media/pensionFunds_header_image.9d1458e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pensionFunds_header_image.jpg
// module id = 477
// module chunks = 21